export const ADDRESS_ACCESS_CONDITIONS = [
  { code: 'B_DOUBLE', label: 'B-Double', requiresValue: false },
  { code: 'SEMI_TRAILER', label: 'Semi Trailer', requiresValue: false },
  { code: 'RIGID', label: 'Rigid', requiresValue: false },
  { code: 'HIAB', label: 'Hiab (Crane Truck)', requiresValue: false },
  { code: 'FORKLIFT_ONSITE', label: 'Forklift Onsite', requiresValue: false },
  { code: 'TAILGATE', label: 'Tailgate', requiresValue: false },
  { code: 'PALLET_JACK', label: 'Pallet Jack Required', requiresValue: false },
  { code: 'CREW_SIZE', label: '1, 2 or 3 man crew', requiresValue: true },
  { code: 'LOADING_DOCK', label: 'Loading dock', requiresValue: false },
  { code: 'GROUND_LEVEL', label: 'Ground level with clear access', requiresValue: false },
  { code: 'REAR_LANE', label: 'Rear lane only', requiresValue: false },
  { code: 'HEIGHT_RESTRICTED', label: 'Height-restricted entry', requiresValue: true },
  { code: 'MAX_SITE_HEIGHT', label: 'Max site height', requiresValue: true },
  { code: 'MAX_SITE_WIDTH', label: 'Max site width', requiresValue: true },
  { code: 'SITE_DETAILS_NOT_AVAILABLE', label: 'Delivery site details not available', requiresValue: false },
] as const;

/** Non-negative decimal metres (up to 2 decimal places). Empty is allowed (unknown). */
export const NON_NEGATIVE_METRE_DECIMAL_PATTERN = /^\d+(\.\d{1,2})?$/;

export function isValidNonNegativeMetreDecimal(value: string | null | undefined): boolean {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) return true;
  return NON_NEGATIVE_METRE_DECIMAL_PATTERN.test(trimmed) && Number(trimmed) >= 0;
}

export type AddressAccessConditionCode = (typeof ADDRESS_ACCESS_CONDITIONS)[number]['code'];

export interface AddressAccessCondition {
  code: AddressAccessConditionCode;
  value?: string | null;
}

export const ADDRESS_ACCESS_CONDITION_CODES = ADDRESS_ACCESS_CONDITIONS.map((condition) => condition.code);

export function getAddressAccessConditionLabel(code: AddressAccessConditionCode | string | null | undefined): string {
  if (!code) return 'Not specified';
  return ADDRESS_ACCESS_CONDITIONS.find((condition) => condition.code === code)?.label ?? code;
}

export function addressAccessConditionRequiresValue(code: AddressAccessConditionCode | string | null | undefined): boolean {
  return (
    code === 'HEIGHT_RESTRICTED' ||
    code === 'MAX_SITE_HEIGHT' ||
    code === 'MAX_SITE_WIDTH' ||
    code === 'CREW_SIZE'
  );
}

export function formatAddressAccessCondition(condition: AddressAccessCondition): string {
  const label = getAddressAccessConditionLabel(condition.code);
  const value = condition.value?.trim();

  if (condition.code === 'HEIGHT_RESTRICTED' && value) {
    return `${label}: ${value}m`;
  }
  if ((condition.code === 'MAX_SITE_HEIGHT' || condition.code === 'MAX_SITE_WIDTH') && value) {
    return `${label}: ${value}m`;
  }
  if (condition.code === 'CREW_SIZE' && value) {
    return `${value}-man crew`;
  }
  return label;
}
